import React, { Component } from "react";
import { Drawer, Form, Input, Button } from "antd";
import type { FormInstance } from "antd/es/form";

interface EditHandlers {
  closeDrawer: () => void;
  onFinish: (values: any) => void;
}

interface EditValues {
  visible: boolean;
  form: FormInstance<any>;
  editingRow: any;
}

export default class EditApplicationSetting extends Component<{
  handlers: EditHandlers;
  values: EditValues;
}> {
  render() {
    const { handlers, values } = this.props;
    const { visible, form, editingRow } = values;
    const { closeDrawer, onFinish } = handlers;

    return (
      <Drawer
        title="Edit Application Setting"
        open={visible}
        width={480}
        onClose={closeDrawer}
        className="manage-pages-drawer edit-app-setting-drawer"
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            key: editingRow?.key,
            value: editingRow,
            category: editingRow?.category,
            description: editingRow?.description,
            reason: editingRow?.reason
          }}
          onFinish={(vals) => {
            onFinish(vals);
            closeDrawer();
          }}
        >
          <Form.Item name="key" label="Key">
            <Input disabled />
          </Form.Item>

          <Form.Item
            name="value"
            label="Value"
            rules={[{ required: true }]}
          >
            <Input.TextArea rows={6} />
          </Form.Item>

          <Form.Item
            name="category"
            label="Type"
          >
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Description (Validate Message or etc.)">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item name="reason" label="Reason">
            <Input.TextArea rows={2} />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Update
          </Button>
        </Form>
      </Drawer>
    );
  }
}
